/**
 * Encryption of registration challenge payload.
 */

import { CryptoContext } from '../base';
import { RegisterChallengeConfigDumpArgs, RegisterChallengeConfigLoadArgs } from './args';
import { RegisterChallengeConfigV1 } from './v1';
import { RegisterChallengeConfigV2 } from './v2';
import { CU_ANNULLED_BY_PQC_ML, CU_PQC_ML } from '../feature';

export let REGISTER_CHALLENGE_CRYPTO_CONTEXT = new CryptoContext<
  RegisterChallengeConfigLoadArgs,
  RegisterChallengeConfigDumpArgs
>(
  [new RegisterChallengeConfigV1(CU_ANNULLED_BY_PQC_ML), new RegisterChallengeConfigV2(CU_PQC_ML)],
  [new Uint8Array([1])]
);
